export type SelectOption = { label: string; value: string };
export const isSelectOption = (option: SelectOption | string): option is SelectOption => typeof option !== 'string';
